import { getPipeFileName } from './common.ts';
import type { PipeNameProperties, PipeServerOptions } from './types.ts';
import { createServer } from 'node:net';

function getDiscoveryPipeFileName({ environment, region, user }: PipeNameProperties) {
    return getPipeFileName(`glue42-${environment}-${region}-${user}`);
}

export function gatewayDiscoveryPipeServer({ logger, info, pipeNameProps }: PipeServerOptions) {
    const pipeName = getDiscoveryPipeFileName(pipeNameProps);
    logger.info(`gateway started: ${info}, opening ${pipeName}`);
    const server = createServer((stream) => {
        logger.info(`stream connected, sending info...`);
        stream.write(info);
        stream.end(() => {
            server.close();
        });
    });
    server.listen(pipeName);
    return server;
}
